// @flow
import GenericSlider from '@components/sliders/GenericSlider';

import type { NonNullType } from '@types/misc';
import type { FluorescenceSearchFilterType } from '@types/search';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as FluorescenceContent from '@components/popups/content/Fluorescence';

const steps = ['None', 'Faint', 'Medium', 'Strong', 'Very Strong'];
const baseSliderOpts = {
  range: {
    min: 0,
    max: steps.length
  },
  step: 1,
  margin: 1,
  connect: [false, true, false]
};

function getStartValues(stateValues = []) {
  if (stateValues.length === 0) return [0, steps.length];

  let min = steps.length; // start at the max possible
  let max = 0; // start at the min possible

  stateValues.forEach(value => {
    const index = steps.indexOf(value);
    if (min > index) min = index;
    if (max < index) max = index;
  });

  return [min, max + 1];
}

type PropsType = {
  onSliderUpdate: (T: string, I: NonNullType) => void,
  value: FluorescenceSearchFilterType | void
};

const Popup = () => <QuestionMarkPopup initialContent={FluorescenceContent} />;

export default class FluorescenceSlider extends React.Component<PropsType> {
  render() {
    const sliderOpts = {
      ...baseSliderOpts,
      start: getStartValues(this.props.value)
    };

    return (
      <GenericSlider
        title={'Fluorescence'}
        sliderMarginTop={'0'}
        titleMarginBottom={'2px'}
        sliderOpts={sliderOpts}
        onSliderUpdate={steps =>
          this.props.onSliderUpdate('UPDATE_FLUORESCENCE', steps)
        }
        Popup={Popup}
        steps={steps}
      />
    );
  }
}
